module.exports = __webpack_public_path__ + "img/hexnode.19459ffc.png";